(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.querySelectorAll('[data-nutrise-nav] details').forEach((details) => {
    details.querySelector('summary').addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) return;
      if (event.detail > 0 && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        event.preventDefault();
        details.open = true;
      }
    });
    details.addEventListener('pointerenter', (event) => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      details.closest('header').querySelectorAll('[data-nutrise-nav] details[open]').forEach((other) => {
        if (other !== details) other.open = false;
      });
      const headerBottom = details.closest('header').getBoundingClientRect().bottom;
      const summaryBottom = details.querySelector('summary').getBoundingClientRect().bottom;
      details.style.setProperty('--nh-nav-bridge-height', `${Math.max(0, Math.ceil(headerBottom - summaryBottom)) + 1}px`);
      details.open = true;
    });
    details.addEventListener('pointerleave', () => {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) details.open = false;
    });
    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        details.open = false;
        details.querySelector('summary').focus();
      }
    });
    details.addEventListener('focusout', (event) => {
      if (!details.contains(event.relatedTarget) && !details.matches(':hover')) details.open = false;
    });
  });
  if (!window.nhSiteHeaderScrollReady) {
    window.nhSiteHeaderScrollReady = true;
    const updateSiteHeader = () => {
      document.body.classList.toggle('nh-site-header-solid', window.scrollY > 24);
    };
    window.addEventListener('scroll', updateSiteHeader, { passive: true });
    window.addEventListener('pageshow', updateSiteHeader);
    updateSiteHeader();
  }
  if (!window.nhSiteHeaderLayoutReady) {
    window.nhSiteHeaderLayoutReady = true;
    const root = document.documentElement;
    const siteHeader = document.querySelector('.section-header');
    const productBreadcrumb = document.body.classList.contains('template-product')
      ? document.querySelector('#MainContent > .nh-breadcrumb-region')
      : null;
    const updateSiteHeaderLayout = () => {
      if (siteHeader) root.style.setProperty('--header-height', siteHeader.offsetHeight + 'px');
      root.style.setProperty('--nh-product-breadcrumb-height', (productBreadcrumb ? productBreadcrumb.offsetHeight : 0) + 'px');
    };
    updateSiteHeaderLayout();
    const layoutObserver = new ResizeObserver(updateSiteHeaderLayout);
    if (siteHeader) layoutObserver.observe(siteHeader);
    if (productBreadcrumb) layoutObserver.observe(productBreadcrumb);
    window.addEventListener('pageshow', updateSiteHeaderLayout);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-community-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const mobile = window.matchMedia('(max-width: 749px)');
    const prepare = scope => {
      scope.querySelectorAll('.nh-community__carousel .jdgm-cards-carousel').forEach(carousel => {
        const arrows = carousel.querySelectorAll('.jdgm-arrow');
        if (arrows.length !== 2) return;
        arrows[0].dataset.nhReviewDirection = 'previous';
        arrows[1].dataset.nhReviewDirection = 'next';
        if (initialized.has(carousel)) return;
        initialized.add(carousel);
        /* Let Judge.me measure the card viewport after the arrows leave the layout. */
        if (mobile.matches) requestAnimationFrame(() => {
          requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
        });
      });
    };
    const observe = section => {
      prepare(section);
      const observer = new MutationObserver(() => {
        if (!section.isConnected) { observer.disconnect(); return; }
        prepare(section);
      });
      observer.observe(section, { childList: true, subtree: true });
    };
    document.querySelectorAll('.nh-community').forEach(observe);
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('.nh-community').forEach(observe);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nh-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('.nh-home__play');
  if (!button) return;
  const video = button.previousElementSibling;
  if (!video.src) video.src = video.dataset.videoSrc;
  video.play().then(function() { button.hidden = true; }).catch(function() { button.hidden = false; });
});

if (!customElements.get('nh-scroll-video')) {
  customElements.define('nh-scroll-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.video.muted = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.loadVideo = () => {
        if (this.loaded) return;
        this.video.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
        });
        this.video.load();
        this.loaded = true;
      };
      this.onVisibility = () => {
        if (!this.inView || document.hidden) { this.video.pause(); return; }
        this.loadVideo();
        if (this.motion.matches) { this.video.controls = true; return; }
        this.video.play().catch(() => { this.video.controls = true; });
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          this.onVisibility();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      } else {
        this.video.controls = true;
        this.fallback = () => {
          const rect = this.getBoundingClientRect();
          this.inView = rect.top < window.innerHeight && rect.bottom > 0;
          this.onVisibility();
        };
        window.addEventListener('scroll', this.fallback, { passive: true });
        window.addEventListener('resize', this.fallback);
        this.fallback();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.fallback) {
        window.removeEventListener('scroll', this.fallback);
        window.removeEventListener('resize', this.fallback);
      }
      this.video?.pause();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrise-category-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nutrise-lazy-reviews')) {
  customElements.define('nutrise-lazy-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.details = this.closest('details');
      this.status = this.querySelector('[data-status]');
      this.retry = this.querySelector('[data-retry]');
      this.content = this.querySelector('[data-content]');
      this.details.addEventListener('toggle', () => { if (this.details.open) this.load(); });
      this.retry.addEventListener('click', () => this.load());
      if (this.details.open) this.load();
    }
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.attempt = (this.attempt || 0) + 1;
      this.status.hidden = false;
      this.status.textContent = 'Bewertungen werden geladen …';
      this.retry.hidden = true;
      this.content.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: AbortSignal.timeout(20000) });
        if (!response.ok) throw new Error('Review section unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const widget = doc.querySelector('[data-widget="all-reviews-v2025"]');
        const data = doc.querySelector('[data-nutrise-review-data]');
        if (!widget || !data || !window.jdgm?.CDN_BASE_URL) throw new Error('Reviews unavailable');
        window.jdgm.data ||= {};
        window.jdgm.data.allReviewsWidgetV2025 = JSON.parse(data.textContent);
        const base = window.jdgm.CDN_BASE_URL;
        const manifestResponse = await fetch(new URL('manifest.json', base), { signal: AbortSignal.timeout(20000) });
        if (!manifestResponse.ok) throw new Error('Review styles unavailable');
        const manifest = await manifestResponse.json();
        const visited = new Set();
        const styles = new Set();
        const collect = (key) => {
          if (visited.has(key)) return;
          visited.add(key);
          const entry = manifest[key];
          if (!entry) return;
          (entry.css || []).forEach(css => styles.add(new URL(css, base).href));
          (entry.imports || []).forEach(collect);
        };
        collect(widget.dataset.entryKey);
        await Promise.all([...styles].map(href => new Promise((resolve, reject) => {
          if ([...document.querySelectorAll('link[rel="stylesheet"]')].some(link => link.href === href && link.sheet)) return resolve();
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;
          const timeout = setTimeout(() => { link.remove(); reject(new Error('Styles timed out')); }, 20000);
          link.onload = () => { clearTimeout(timeout); resolve(); };
          link.onerror = () => { clearTimeout(timeout); link.remove(); reject(new Error('Styles failed')); };
          document.head.appendChild(link);
        })));
        this.content.replaceChildren(widget);
        const entryUrl = new URL(widget.dataset.entryPoint, base);
        if (this.attempt > 1) entryUrl.searchParams.set('nutrise_retry', this.attempt);
        await import(entryUrl.href);
        await new Promise((resolve, reject) => {
          let timeout;
          const observer = new MutationObserver(check);
          function check() {
            if (widget.querySelector('button, [role="tab"], h2')) {
              observer.disconnect(); clearTimeout(timeout); resolve();
            }
          }
          observer.observe(widget, { childList: true, subtree: true });
          timeout = setTimeout(() => { observer.disconnect(); reject(new Error('Reviews timed out')); }, 25000);
          check();
        });
        this.loaded = true;
        this.status.hidden = true;
      } catch (error) {
        this.content.replaceChildren();
        this.status.textContent = 'Die Bewertungen konnten gerade nicht geladen werden. Bitte versuche es erneut.';
        this.retry.hidden = false;
      } finally {
        this.loading = false;
        this.content.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrise-other-goals"] && !Shopify.designMode) return;
  try {
    
const initNutriseGoalNavigation = root => {
  root.querySelectorAll('.nutrise-other-goals').forEach(section => {
    const grid = section.querySelector('.nutrise-other-goals__grid');
    if (!grid || grid.dataset.navigationReady) return;
    grid.dataset.navigationReady = 'true';
    const arrows = [...section.querySelectorAll('.nutrise-other-goals__arrow')];
    const update = () => {
      arrows[0].disabled = grid.scrollLeft <= 2;
      arrows[1].disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2;
    };
    arrows.forEach(button => button.addEventListener('click', () => {
      grid.scrollBy({ left: button.dataset.direction * (grid.querySelector('.nutrise-other-goals__card')?.getBoundingClientRect().width || grid.clientWidth), behavior: 'smooth' });
    }));
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('pageshow', () => { grid.scrollLeft = 0; update(); });
    requestAnimationFrame(() => { grid.scrollLeft = 0; update(); });
  });
};
initNutriseGoalNavigation(document);
document.addEventListener('shopify:section:load', event => initNutriseGoalNavigation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrise-ready-bundles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nutrise-bundle-add]').forEach((button) => {
    if (button.dataset.nutriseBound === 'true') return;
    button.dataset.nutriseBound = 'true';

    button.addEventListener('click', async () => {
      const label = button.querySelector('span');
      const originalText = label.textContent;
      const variantIds = button.dataset.variants.split(',').filter(Boolean);

      if (variantIds.length < 2) return;

      button.disabled = true;
      label.textContent = button.dataset.loadingText;

      try {
        const response = await fetch(button.dataset.cartUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: variantIds.map((id) => ({ id: Number(id), quantity: 1 })) })
        });

        if (!response.ok) throw new Error('Bundle add failed');
        window.location.assign(button.dataset.cartPageUrl);
      } catch (error) {
        label.textContent = button.dataset.errorText;
        window.setTimeout(() => {
          label.textContent = originalText;
          button.disabled = false;
        }, 2400);
      }
    });
  });

  (() => {
    const section = document.getElementById('kombinationen');
    if (!section) return;

    const cards = Array.from(section.querySelectorAll('[data-nrb-focus]'));
    const heading = section.querySelector('[data-nrb-heading]');
    const focusLinks = Array.from(document.querySelectorAll('a[href^="#kombinationen-"]'));

    if (cards.length === 0 || section.dataset.nrbBound === 'true') return;

    section.dataset.nrbBound = 'true';

    const availableFocuses = new Set(cards.map((card) => card.dataset.nrbFocus).filter(Boolean));

    const activateFocus = (focus, updateHash = false) => {
      if (!availableFocuses.has(focus)) return;

      focusLinks.forEach((link) => {
        const isActive = link.getAttribute('href') === `#kombinationen-${focus}`;
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      cards.forEach((card) => {
        card.hidden = card.dataset.nrbFocus !== focus;
      });

      if (heading) {
        const activeCard = cards.find((card) => card.dataset.nrbFocus === focus);
        const prefix = heading.dataset.nrbHeadingPrefix;
        if (activeCard && activeCard.dataset.nrbFocusLabel && prefix) {
          heading.textContent = `${prefix} ${activeCard.dataset.nrbFocusLabel}`;
        }
      }

      if (updateHash) {
        window.history.replaceState(null, '', `#kombinationen-${focus}`);
      }
    };

    const focusFromHash = () => {
      const prefix = '#kombinationen-';
      return window.location.hash.startsWith(prefix) ? window.location.hash.slice(prefix.length) : '';
    };

    focusLinks.forEach((link) => {
      if (link.dataset.nrbLinkBound === 'true') return;
      link.dataset.nrbLinkBound = 'true';

      link.addEventListener('click', (event) => {
        const targetHash = link.getAttribute('href');
        const focus = targetHash.replace('#kombinationen-', '');
        if (!availableFocuses.has(focus)) return;

        event.preventDefault();
        activateFocus(focus, true);
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    window.addEventListener('hashchange', () => {
      const requestedFocus = focusFromHash();
      if (requestedFocus) activateFocus(requestedFocus);
    });

    const initialFocus = focusFromHash();
    activateFocus(availableFocuses.has(initialFocus) ? initialFocus : cards[0].dataset.nrbFocus);
  })();

  } catch(e) { console.error(e); }
})();
})();
